import { Component, inject } from '@angular/core';
import { AppConstants } from '../../core/common/app-constants';
import { Router } from '@angular/router';


@Component({
selector: 'app-servicios',
standalone: true,
templateUrl: './servicios.component.html',
styleUrls: ['./servicios.component.scss']
})
export class ServiciosComponent {
  private router = inject(Router);
  servicios: any[] = AppConstants.PlanesCentrix.Servicios;

  saberMas(url: any){
    this.router.navigate([url]);
  }

}